import { render, staticRenderFns } from "./DetailsDashboardProcessing.vue?vue&type=template&id=b62332f4&scoped=true"
import script from "./DetailsDashboardProcessing.vue?vue&type=script&lang=js"
export * from "./DetailsDashboardProcessing.vue?vue&type=script&lang=js"
import style0 from "./DetailsDashboardProcessing.vue?vue&type=style&index=0&id=b62332f4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62332f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b62332f4')) {
      api.createRecord('b62332f4', component.options)
    } else {
      api.reload('b62332f4', component.options)
    }
    module.hot.accept("./DetailsDashboardProcessing.vue?vue&type=template&id=b62332f4&scoped=true", function () {
      api.rerender('b62332f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Painel/components/DetailsDashboardProcessing.vue"
export default component.exports